import React from "react";
import { C, inp as inpStyle } from "../../../../lib/styles.js";

// Shared 5-field venue/address/city/state/zip editor. Used by both the root Job Card Location
// section and the per-session editor. Background token lets the session variant sit on surfaceAlt.
export default function LocationInputs({ value, onField, disabled, background }) {
  const style = { ...inpStyle, background: background || inpStyle.background };
  return (
    <>
      <div className="jc-loc-grid" style={S.grid}>
        <input style={style} disabled={disabled} value={value.locationVenue || ""} onChange={e => onField("locationVenue", e.target.value)} placeholder="Venue / Location name" />
        <input style={style} disabled={disabled} value={value.locationAddress || ""} onChange={e => onField("locationAddress", e.target.value)} placeholder="Street address" />
        <input style={style} disabled={disabled} value={value.locationCity || ""} onChange={e => onField("locationCity", e.target.value)} placeholder="City" />
        <input style={style} disabled={disabled} value={value.locationState || ""} onChange={e => onField("locationState", e.target.value)} placeholder="State" />
      </div>
      <div className="jc-zip" style={{ width: "25%", marginTop: 10, minWidth: 120 }}>
        <input style={style} disabled={disabled} value={value.locationZip || ""} onChange={e => onField("locationZip", e.target.value)} placeholder="Zip" />
      </div>
    </>
  );
}

const S = {
  grid: { display: "grid", gridTemplateColumns: "2fr 1fr 0.6fr 0.6fr", gap: 10 },
};
